import {initTelemetry, type Telemetry} from '@packages/systems/telemetry';
import {type TelemetryContext} from './types';

export const telemetry: Telemetry<TelemetryContext> = initTelemetry();
